import { useMCPTT } from "../mcptt/hooks";

interface Props {
  /** Called when the operator clicks an emergency row — focus the
   *  map on that device and select the unit in the subscriber list. */
  onFocusEmergency: (userId: string, deviceId: string) => void;
}

/** Pulsing red strip below the app bar while at least one emergency
 *  is active. Each emergency renders as a clickable row with an
 *  inline ACK button. Clicking the row (anywhere except ACK) focuses
 *  the unit on the map; clicking ACK fires EMERGENCY_ACK on the wire. */
export function EmergencyBanner({ onFocusEmergency }: Props) {
  const { snapshot, ackEmergency } = useMCPTT();
  const list = Array.from(snapshot.emergencies.values());
  if (list.length === 0) return null;

  return (
    <div className="emergency-banner">
      <div className="emg-stack">
        <div className="emg-stack-head">
          <span className="emg-label">EMERGENCY</span>
          <span className="emg-meta">
            {list.length === 1 ? "1 ACTIVE" : `${list.length} ACTIVE`}
          </span>
        </div>
        <div className="emg-rows">
          {list.map((e) => (
            <div
              key={e.EmergencyID}
              className="emg-row"
              role="button"
              tabIndex={0}
              onClick={() => onFocusEmergency(e.UserID, e.DeviceID)}
              onKeyDown={(ev) => {
                if (ev.key === "Enter" || ev.key === " ") {
                  ev.preventDefault();
                  onFocusEmergency(e.UserID, e.DeviceID);
                }
              }}
              title="Click to focus on map"
            >
              <span className="emg-row-name">{e.UserName}</span>
              <span className="emg-row-id">#{e.EmergencyID.slice(0, 6)}</span>
              <span className="emg-row-reason">REASON {e.Reason}</span>
              <span className="emg-spacer" />
              <button
                type="button"
                className="emg-action"
                onClick={(ev) => {
                  ev.stopPropagation();
                  ackEmergency(e.EmergencyID, e.NetworkID);
                }}
              >
                ACK
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
